export default "__VITE_ASSET__BQb47LOg__"